import React from 'react'
import Layout from '../Layout/Layout'

const Climatic_change = () => {
  return (
    <Layout>
          <div className='uk-container uk-margin-large-top'>
             <div className='uk-grid'>
                <div className='uk-width-3-4'>
                         <h1 className='light uk-margin-large-top'>Climate Change</h1>

                 <p className='light'>Climate change is causing global disruption, with vulnerable communities and ecosystems most affected.
supports the development and scaling of sustainable ventures through tailored business creation and acceleration programmes.</p>
     
     <p className='light'>collaborates with partner organisations to foster entrepreneurship activities that support local climate goals;
provides educational and upskilling programmes to equip public and private leadership with innovation capacities essential for tackling climate change
helps test and implement new ideas by supporting innovation projects that drive decarbonisation and strengthen climate resilience.</p>

                </div>

                  <div className='uk-width-1-4'>

                </div>



               
             </div>

          </div>


    </Layout>
  )
}

export default Climatic_change

